import React, { createContext, useContext, useState, useEffect } from 'react';

const BranchContext = createContext();

export const BranchProvider = ({ children }) => {
  const [branch, setBranch] = useState(null);

  useEffect(() => {
    const storedBranch = localStorage.getItem('branch');

    if (storedBranch && storedBranch !== "undefined") {
      setBranch(JSON.parse(storedBranch));
    }
  }, []);

  const updateBranch = (newBranch) => {
    setBranch(newBranch);
    localStorage.setItem('branch', JSON.stringify(newBranch));
  };

  const clearBranch = () => {
    setBranch(null);
    localStorage.removeItem('branch');
  };

  return (
    <BranchContext.Provider value={{ branch, updateBranch, clearBranch }}>
      {children}
    </BranchContext.Provider>
  );
};

export const useBranch = () => {
  return useContext(BranchContext);
};
